import { useToast } from "../../utils/toast";
import { Fieldset } from "primereact/fieldset";
import { ForumTopicEnum, ForumWithoutMessage, getColorForLetter } from "../../services/forum/forum.dto";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { DataView } from "primereact/dataview";
import classNames from "classnames";
import forumService from "../../services/forum/forum.service";
import { BreadCrumb } from "primereact/breadcrumb";
import { MenuItem } from "primereact/menuitem";

export interface CardDataDto {
  imgSrc: string;
  title: string;
  description: string;
  value: ForumTopicEnum;
}

export const cardData: CardDataDto[] = [
  {
    imgSrc: "/images/landing-page/hesaplama.jpg",
    title: "Son Açılan Konular",
    description: "Kullanıcılar tarafından en son oluşturulan konuları görüntüleyebilirsiniz.",
    value: ForumTopicEnum.GENEL
  },
  {
    imgSrc: "/images/forum/yesil-donusum.jpg",
    title: "Yeşil Dönüşüm",
    description: "Sürdürülebilirlik, çevresel performans, iyileştirme ve malzeme-kaynak yönetimi raporları.",
    value: ForumTopicEnum.YESIL_DONUSUM
  },
  {
    imgSrc: "/images/forum/dijital-donusum.jpg",
    title: "Dijital Dönüşüm",
    description:
      "Yeşil dönüşüm olgunluk analizi, dijital dönüşüm endeksi ve sektör/bölge/ülke genelindeki istatistikler ve raporlar.",
    value: ForumTopicEnum.DIJITAL_DONUSUM
  },
  {
    imgSrc: "/images/landing-page/egitim.jpg",
    title: "Eğitim",
    description: "Sürdürülebim değişikliğine uyum eğitimleri.",
    value: ForumTopicEnum.EGITIM
  },
  {
    imgSrc: "/images/landing-page/afad.jpg",
    title: "İş Sürekliliği",
    description:
      "Afet durumunda sanayi kuruluşlarının kesintisiz faaliyet göstermesi için AFAD ve Sanayi Bakanlığı ile geliştirdiğimiz işbirliği çalışmaları.",
    value: ForumTopicEnum.IS_GELISTIRME
  },
  {
    imgSrc: "/images/forum/arge.jpg",
    title: "ARGE",
    description: "Türkiye genelindeki organijeler ve sektörel gelişmeler.",
    value: ForumTopicEnum.ARGE
  },
  {
    imgSrc: "/images/forum/kapasite-gelistirme.jpg",
    title: "Kapasite Geliştirme",
    description: "Sanayi kuruluşlarının üretim kapasitelerini artırmaya yönelik stratejik işbirliği çalışmaları.",
    value: ForumTopicEnum.KAPASITE_GELISTIRME
  },
  {
    imgSrc: "/images/forum/is-surekliligi.jpg",
    title: "İş Geliştirme",
    description:
      "Türkiye genelindeki organize sanayi bölgelerinin iş sürekliliği planları ve sektörel gelişmelere dair bilgiler.",
    value: ForumTopicEnum.IS_SUREKLILIGI
  }
];

const ForumHomePage = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  //const [selectedCard, setSelectedCard] = useState<CardDataDto>(cardData[0]);
  //const [forums, setForums] = useState<ForumWithoutMessage[]>([]);
  //const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const items: MenuItem[] = [{ label: "Forum" }];
  const home: MenuItem = {
    icon: "pi pi-home",
    command: () => {
      navigate("/app/forum-homepage");
    }
  };

  const changeTopic = (card: CardDataDto) => {
    if (card.value != null) {
      const topicId = card.value.toString();
      navigate(`/app/forum-page/${topicId}`);
    }
  };

  function handleSearch(searchTerm: string): void {
    navigate(`/app/forum-page/${"1"}`, { state: { searchTerm } });
  }

  return (
    <div className="card p-1 lg:p-3">
      <BreadCrumb className="mb-3 mx-0 lg:mx-2" model={items} home={home} />

      <div className="flex flex-column lg:flex-row justify-content-between mb-4 mx-0 lg:mx-2">
        <div className="p-inputgroup flex-1 mb-3 lg:mb-0 lg:mr-2">
          <input
            type="text"
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            placeholder="Konuları ara..."
            className="p-inputtext p-component w-full"
          />
          <Button
            label="Ara"
            icon="pi pi-search"
            className="p-button-outlined"
            onClick={() => handleSearch(searchTerm)}
          />
        </div>
        <Button label="Yeni Konu Aç" className="w-full lg:w-auto" onClick={() => navigate("/app/forum-ekle")} />
      </div>

      <div id="features" className="py-2 px-1 mt-2 mx-0 lg:mx-2">
        <div className="grid justify-content-center">
          <div className="grid">
            {cardData.map((card, index) => (
              <div className="col-12 md:col-6 lg:col-3" key={index}>
                <div
                  className="card hover-card cursor-pointer"
                  style={{ height: "8rem", padding: "1rem" }}
                  onClick={() => changeTopic(card)}
                >
                  <div className="flex align-items-center">
                    <img src={card.imgSrc} className="shadow-2 w-6rem h-6rem mr-3" />
                    <div className="flex flex-column justify-content-center">
                      <h5 className="mb-1 text-900 text-lg">{card.title}</h5>
                      {/* <span className="text-600 text-sm">{card.description}</span> */}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForumHomePage;
